<template>
    <div>
        <popup-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :setFilter="setFilter"></popup-filter-link>
        <popup-list-link :listLayout="listLayout" :paginationData="filterSet.page" :popupData="List" :setData="setData"></popup-list-link>
        <pagination-link :paginationLayout="paginationLayout" :type="'next'" :paginationData="filterSet.page" :setPage="setPage" :listLength="List.length" :setData="setData"></pagination-link>
    </div>
</template>

<script>
    import alertMixins from "@/mixins/alertMixins";
    import PopupFilterLink from "@/components/popup/PopupFilterLink";
    import PopupListLink from "@/components/popup/PopupListLink";
    import PaginationLink from "@/components/popup/PaginationLink";
    import popupUtil from "@/components/popup/popupUtil";
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import EventBus from "@/utils/event-bus";
    import DeleteClass from "@/mixins/deleteClass";
    const {filterConfig} = popupUtil;

    export default {
        name: 'PopupListComponent',
        components: {
            PopupFilterLink,
            PopupListLink,
            PaginationLink,
        },
        mixins: [ alertMixins, filterMixins, listMixins, popupUtil ],
        props: {
            popupType: {},
        },
        data() {
            return{
                listLayout: '',
                filterLayout: '',
                paginationLayout: '',
                paginationType: '',
                listApiParamSet: {},

                searchInput: '',
                searchInputOption: 'su',
                filterDate: ['', ''],

                selectArr: [],

                deleteIndex: 0,
                deleteLastIndex: 0,
            }
        },
        created() {
            this.initConfig();
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
            this.newDeleteClass();
        },
        mounted() {
            this.getList(true);
            EventBus.$on('deletePopup', this.deletePopupConfirm)
        },
        beforeDestroy() {
            EventBus.$off('deletePopup')
        },
        computed: {
        },
        methods: {
            initConfig() {
                let popupConfig = this.returnPopupConfig(this.popupType);

                this.listLayout = popupConfig.listLayout;
                this.filterLayout = popupConfig.filterLayout;
                this.paginationLayout = popupConfig.paginationLayout;
                this.paginationType = popupConfig.paginationType;
                this.listApiParamSet = popupConfig.listApiParamSet;
                this.deleteFunc = popupConfig.deleteFunc;
                this.deleteApiParamsSet = popupConfig.deleteApiParamsSet;
                this.deleteSuccessType = popupConfig.deleteSuccessType;
                this.deleteFailTypes = popupConfig.deleteFailTypes;
                this.keyName = popupConfig.keyName;

                let pageRow = popupConfig.pageRow ? popupConfig.pageRow : 10;
                if(pageRow != this.filterSet.page.size) {
                    this.filterSet.page.size = pageRow;
                }

                let listOptions = {
                    url : this.$api.$popup.getPopup,
                    defaultParams : this.listApiParamSet,
                }
                this.initList('api', listOptions);
            },
            setData(key, value) {
                this[key] = value;
            },

            newDeleteClass() {
                let deleteOptions = {
                    func: this.$api.$popup[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            },
            deletePopupConfirm() {
                if(this.selectArr.length === 0) {
                    this.errorAlert('목록을 선택해주세요.');
                    return false;
                }
                this.createConfirm({
                    content: '정말 삭제하시겠습니까?',
                    confirm: () => {
                        this.deleteIndex = 0;
                        this.deleteLastIndex = this.selectArr.length - 1;
                        this.runDelete();
                    }
                })
            },
            runDelete() {
                this.DeleteClass.runDelete(this.selectArr[this.deleteIndex]);
            },
            deleteAfterFunc() {
                if(this.deleteIndex < this.deleteLastIndex) {
                    this.deleteIndex = this.deleteIndex + 1;
                    this.runDelete()
                }else{
                    this.createAlert({
                        content: '삭제되었습니다.',
                        hide: () => {
                            this.getList();
                        }
                    })
                }
            },
        }
    }
</script>
